import { AppConfig } from './config.types';

const getApiUrl = (): string => {
  if (!process.env.REACT_APP_API_URL) {
    throw Error('Missing environment variable REACT_APP_API_URL');
  }

  return process.env.REACT_APP_API_URL;
};

const getGuidedSignInApiUrl = (): string => {
  if (!process.env.REACT_APP_GUIDED_SIGNIN_API_URL) {
    throw Error('Missing environment variable REACT_APP_GUIDED_SIGNIN_API_URL');
  }

  return process.env.REACT_APP_GUIDED_SIGNIN_API_URL;
};

const getAuthorizationApiUrl = (): string => {
  if (!process.env.REACT_APP_AUTHORIZATION_API_URL) {
    throw Error('Missing environment variable REACT_APP_AUTHORIZATION_API_URL');
  }

  return process.env.REACT_APP_AUTHORIZATION_API_URL;
};

export const appConfig: AppConfig = {
  apiUrl: getApiUrl(),
  guidedSignInApiUrl: getGuidedSignInApiUrl(),
  authorizationApiUrl: getAuthorizationApiUrl(),
};

export const POLICY_URL = 'https://www.mgmresorts.com/en/privacy-policy.html';
export const RULES_URL = 'https://www.mgmresorts.com/en/mlife-rewards-program/program-rules.html';
export const CONTACT_US_URL = 'https://www.mgmresorts.com/en/company/contact-us.html';
export const TERMS_OF_USE_URL = 'https://www.mgmresorts.com/en/terms-of-use.html';
export const CALIFORNIA_NOTICE_URL =
  'https://www.mgmresorts.com/en/privacy-policy.html#otnotice-section-98502cc7-503e-4247-bc85-aaa7e4df5e9f';
export const CALIFORNIA_FINANCE_INCENTIVE_URL =
  'https://www.mgmresorts.com/en/privacy-policy.html#otnotice-section-34e95f69-c3cd-418e-8048-3282fdce4c22';
export const COLORADO_PROGRAM_NOTICE_URL =
  'https://www.mgmresorts.com/en/privacy-policy.html#otnotice-section-aa31f24b-aee1-45e0-a227-3fc53bb41a8e';
